// EN/NL taal-toggle. Standaard EN. Swapt tekst via data-en/data-nl (of data-en-placeholder/
// data-nl-placeholder voor inputs). Alleen textContent, geen innerHTML nodig — regels die eerst
// samen in 1 element met <br> stonden zijn opgesplitst in losse spans rond een vaste <br>.
(function () {
  var KEY = 'lb8-lang';
  var btn = document.getElementById('lang-toggle');

  function apply(lang) {
    document.documentElement.lang = lang;
    document.querySelectorAll('[data-en]').forEach(function (el) {
      var val = lang === 'nl' ? el.getAttribute('data-nl') : el.getAttribute('data-en');
      if (val != null) el.textContent = val;
    });
    document.querySelectorAll('[data-en-placeholder]').forEach(function (el) {
      var val = lang === 'nl' ? el.getAttribute('data-nl-placeholder') : el.getAttribute('data-en-placeholder');
      if (val != null) el.setAttribute('placeholder', val);
    });
    if (btn) btn.setAttribute('data-lang', lang);
  }

  var start = localStorage.getItem(KEY) || 'en';
  apply(start);

  if (btn) {
    btn.addEventListener('click', function () {
      var next = document.documentElement.lang === 'nl' ? 'en' : 'nl';
      localStorage.setItem(KEY, next);
      apply(next);
    });
  }
})();
